import { render, staticRenderFns } from "./ImpersonateBadge.vue?vue&type=template&id=a5f16a4a&"
import script from "./ImpersonateBadge.vue?vue&type=script&lang=js&"
export * from "./ImpersonateBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports